import { ENV_NAME, getEnvironment } from '@heidi/api/config';
import { atom } from 'jotai';

import {
  COMPLIMENTARY_ENDED_VARIANTS,
  type ComplimentaryEndedVariantId,
} from './complimentary-ended-variants';

// In memory only, so a forced ended modal never outlives a reload or sign-out.
export const complimentaryTrialEndedDevOverrideAtom =
  atom<ComplimentaryEndedVariantId | null>(null);

/** The forced variant, or `null` when no override applies or in production. */
export function applyComplimentaryTrialEndedDevOverride(
  override: ComplimentaryEndedVariantId | null
): ComplimentaryEndedVariantId | null {
  if (override == null || getEnvironment() === ENV_NAME.PROD) return null;
  return override in COMPLIMENTARY_ENDED_VARIANTS ? override : null;
}
